/**
 * ハッシュ付きのリンクをスムーススクロールで移動
 * ページ読み込み時にハッシュと同じ id 属性があれば、その要素に移動
 * https://github.com/tsuyoshiwada/sweet-scroll
 */
import SweetScroll from 'sweet-scroll';
var baseNameAttr = 'a[href*="#"]:not([href*="/"]):not(#goPageTop)'; // ハッシュ付きリンクをトリガとする

var headerElement = '#header'; // 固定ヘッダの CSS セレクタ

document.addEventListener('DOMContentLoaded', function () {
  var scroller = new SweetScroll({
    trigger: baseNameAttr,
    // トリガとなる要素を CSS セレクタで指定
    header: headerElement,
    // 固定ヘッダを CSS セレクタで指定
    duration: 700,
    // アニメーション再生時間のミリ秒
    easing: 'easeOutQuint',
    // イージングのタイプ
    offset: 0,
    // スクロール位置のオフセット
    vertical: true,
    // 垂直方向のスクロールの可否
    horizontal: false,
    // 水平方向のスクロールの可否
    cancellable: true,
    // ホイールやタッチイベントによるスクロールの停止可否
    updateURL: true,
    // スクロール完了後に URL を更新する
    preventDefault: true,
    // コンテナ要素のクリックイベント防止
    stopPropagation: true // コンテナ要素のバブリング防止

  });
  /**
   * ページ読み込み時に URL のハッシュと同じ id 属性があれば、その要素まで移動する
   */

  var locationHash = window.location.hash;
  var hashExists = locationHash.length >= 1;
  if (!hashExists) return;

  if (hashExists) {
    window.location.hash = '';
  }

  window.addEventListener('load', function () {
    var scrollElement = document.getElementById(locationHash.substr(1));
    var needsInitialScroll = scrollElement !== null;

    if (needsInitialScroll) {
      scroller.to(locationHash, {
        updateURL: 'replace'
      });
    }
  });
});